interface Props {
  eventName: string;
  lotteryNumber?: number;
}

export function EventClosedPage({ eventName, lotteryNumber }: Props) {
  return (
    <div>
      <div className="header">
        <div className="logo">Клиника Авиценна</div>
        <h1 className="title">Мероприятие завершено</h1>
        <p className="subtitle">{eventName}</p>
      </div>

      <div className="card">
        <p style={{ margin: 0, lineHeight: 1.5 }}>
          Регистрация и анкетирование на это мероприятие закрыты. Спасибо всем участникам!
        </p>
      </div>

      {lotteryNumber !== undefined && (
        <div className="card lottery">
          <p className="subtitle">Ваш номер для участия в лотерее</p>
          <div className="lottery-number">{lotteryNumber}</div>
        </div>
      )}
    </div>
  );
}
